import ViewManager from '../../../managers/view';
import { tabletBreakpoint } from '../../../constants/breakpoints';

export default class StickyHeader {

  constructor(element) {
    this.element = element;

    this.offsetHeight = null;
    this.offsetTop = null;
    this.liveChatIsLoaded = false;

    this.init();
  }


  init() {
    this.stickyHeaderClass = 'app-header--sticky';
    this.stickyNavClass = 'navbar-collapse--sticky';
    if (!document.body.classList.contains('ExperienceEdit')) {
      ViewManager.on(ViewManager.EVENT_UPDATE, this.onViewUpdate);
    }

    this.toggles = this.element.querySelector('[data-toggles="site-nav"]');
    this.toggleTarget = document.querySelector('[data-toggled-by="site-nav"]');

    this.toggles.addEventListener('click', this.toggleMenu)
  }

  toggleMenu = () => {
    this.toggleTarget.classList.toggle("hidden");
    if (this.toggles.ariaExpanded === 'true') {
      this.toggles.setAttribute('aria-expanded', 'false');
      this.toggleTarget.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll'); // Re-enable scrolling on body
      document.documentElement.style.overflowY = 'scroll'; // Re-enable scrolling on html
    } else {
      this.toggles.setAttribute('aria-expanded', 'true');
      this.toggleTarget.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll'); // Disable scrolling on body
      document.documentElement.style.overflowY = 'hidden'; // Disable scrolling on html
    }
  }

  onViewWillUpdate(data) {
    if (data.resizeUpdate) {
      this.offsetTop = this.element.offsetTop;
      this.offsetHeight = this.element.offsetHeight;
    }
  }

  onViewUpdate = (data) => {
    const bodyContent = document.querySelector(".body-content");
    if (data.scrollUpdate && window.innerWidth > tabletBreakpoint) {
      const header = this.element;
      const headerTop = this.element.querySelector('.navbar-header');
      const marketingBanner = this.element.querySelector(".MarketingBanner");
      const navMenu = header.querySelector('.navbar-collapse');
      let stickyHeaderOffset = 0;
      if (headerTop) stickyHeaderOffset += headerTop.offsetTop;
      if (header) stickyHeaderOffset += header.offsetHeight;
      if (marketingBanner) stickyHeaderOffset -= marketingBanner.offsetHeight;

      if (window.pageYOffset >= stickyHeaderOffset) {
        if (!header.classList.contains(this.stickyHeaderClass)) {
          if (bodyContent) {
            // Add margin to the body-content so the page doesn't jump when the header is set to fixed
            const marginTop = document.querySelector(".app-header").offsetHeight;
            bodyContent.style.marginTop = `${marginTop}px`;
          }
          header.classList.add(this.stickyHeaderClass);
        }
        if (this.pageYOffset > window.pageYOffset && !navMenu.classList.contains(this.stickyNavClass)) {
          navMenu.classList.add(this.stickyNavClass);
        } else if (this.pageYOffset < window.pageYOffset && navMenu.classList.contains(this.stickyNavClass)) {
          navMenu.classList.remove(this.stickyNavClass);
        }
        this.pageYOffset = window.pageYOffset;
      } else {
        header.classList.remove(this.stickyHeaderClass);
        if (bodyContent) {
          // remove margin added above
          bodyContent.style.marginTop = `0px`;
        }
      }
    } else if (data.scrollUpdate && window.innerWidth <= tabletBreakpoint && this.element.classList.contains(this.stickyHeaderClass)) {
      this.element.classList.remove(this.stickyHeaderClass);
    } else if (window.innerWidth <= tabletBreakpoint) {
      // Remove margin if going below tablet when already scrolled
      bodyContent.style.marginTop = `0px`;
    }
  }
}
